import router from '@/router'
import i18n from '@/i18n'

/**
 * 路由工具函数
 */
export const routerUtils = {
  /**
   * 跳转到指定路径
   * @param {string} path - 路径
   */
  push(path) {
    return router.push(path)
  },

  /**
   * 替换当前路由
   * @param {string} path - 路径
   */
  replace(path) {
    return router.replace(path)
  },

  /**
   * 切换语言（不改变路径，只改变语言设置）
   * @param {string} locale - 目标语言代码
   */
  switchLanguage(locale) {
    if (i18n.setLocale) {
      i18n.setLocale(locale)
    } else {
      i18n.locale = locale
      // 手动保存到localStorage
      if (typeof window !== 'undefined') {
        localStorage.setItem('trangpt_locale', locale)
      }
    }
  },

  /**
   * 检查当前路由是否匹配指定路径
   * @param {string} path - 要检查的路径
   */
  isCurrentRoute(path) {
    const currentPath = router.currentRoute.path
    return currentPath === path
  },

  /**
   * 获取当前语言
   */
  getCurrentLocale() {
    return i18n.locale
  }
}

/**
 * Vue插件安装函数
 */
export function install(Vue) {
  Vue.prototype.$routerUtils = routerUtils
}

export default routerUtils